
import RichText from '../../common/RichText.vue'
import Button from '../../storyblok/Button.vue'
export default {
  name: 'SimpleBox',
  components: {
    RichText,
    Button,
  },
  props: {
    title: String,
    content: Array,
    cta: Object,
  }
}
